import { DropButton } from 'grommet';
import styled from 'styled-components';

const CustomDropButton = styled(DropButton)`
  font-weight: ${(props) => (props.bold ? '600' : '400')};
`;

export default CustomDropButton;
